<style src="./BoardLockedTask.scss" lang="scss"></style>
<template>
  <section class="board-locked-task board-content">
    <icon-lock class="icon" />
    <span class="title">Tarefa bloqueada</span>
    <span class="description">Para interagir com essa tarefa é necessário abri-la</span>
    <button
      class="cp1-small-button cp1-button__warning openbutton"
      @click="openTask">
      Abrir Tarefa
    </button>
  </section>
</template>

<script>
import { IconLock } from '@/components/primitives/icons'

export default {
  name: 'BoardLockedTask',
  components: {
    IconLock
  },
  methods: {
    openTask () { this.$emit('open-task') }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/board/components/board-details/components/board-locked-task/BoardLockedTask.vue